module.exports = __webpack_public_path__ + "static/media/resolva_ja_white.51696f41.svg";